// eslint-disable-next-line no-restricted-imports
import {
  CalendarDate,
  CalendarDateTime,
  Time,
  ZonedDateTime,
  now as internationalizedNow,
  today as internationalizedToday,
} from '@internationalized/date';

/**
 * Wrapper function around CalendarDate
 *
 * Instead of using `parseDate` we should use this function to saftely
 * convert a JavaScript date object into a `CalendarDate`.
 *
 * Accept any RFC 3339 Date and turn it into `CalendarDate`.
 */
export function toLocalCalendarDate(value: string): CalendarDate {
  const parsed = new Date(value);

  const year = parsed.getFullYear();
  const month = parsed.getMonth() + 1;
  const day = parsed.getDate();

  return new CalendarDate(year, month, day);
}

/**
 * Wrapper function around `CalendarDateTime`
 *
 * Instead of using `parseDateTime` we should use this function to saftely
 * convert a JavaScript date proto into a `CalendarDate`.
 *
 * Accept any RFC 3339 Date and turn it into `CalendarDateTime`.
 */
export function toLocalCalendarDateTime(value: string): CalendarDateTime {
  const parsed = new Date(value);

  const year = parsed.getFullYear();
  const month = parsed.getMonth() + 1;
  const day = parsed.getDate();
  const hour = parsed.getHours();
  const minute = parsed.getMinutes();
  const second = parsed.getSeconds();
  const millisecond = parsed.getMilliseconds();

  return new CalendarDateTime(year, month, day, hour, minute, second, millisecond);
}

/**
 * Wrapper function around `today()`
 */
export function today(timeZone = 'UTC'): CalendarDate {
  return internationalizedToday(timeZone);
}

/**
 * Wrapper function around `now()`
 */
export function now(timeZone = 'UTC'): ZonedDateTime {
  return internationalizedNow(timeZone);
}

/**
 * Wrapper function around `new Time()`
 */
export function time(...params: ConstructorParameters<typeof Time>) {
  return new Time(...params);
}
